var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForearm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "39px",
    viewBox: "0 0 82 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Forearm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-35",
    transform: "translate(-175.000000, -162.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9465318,119.318148 C11.1403145,129.017207 10.112244,136.278612 9.8623205,141.102364 C9.61239696,145.926116 9.16745437,151.664711 8.52749274,158.318148 L1.69552953,158.318148 C2.50271028,157.996468 2.76663606,154.61901 2.48730686,148.185776 C0.780227838,138.984171 -0.0481541772,129.361629 0.00216081146,119.318148 L12.9465318,119.318148 Z M81.444371,119.318148 C81.494686,129.361629 80.666304,138.984171 78.959225,148.185776 C78.6798958,154.61901 78.9438216,157.996468 79.7510023,158.318148 L79.7510023,158.318148 L72.9190391,158.318148 C72.2790775,151.664711 71.8341349,145.926116 71.5842113,141.102364 C71.3342878,136.278612 70.3062174,129.017207 68.5,119.318148 L68.5,119.318148 Z",
    id: "Forearm"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForearm);
export default __webpack_public_path__ + "static/media/Forearm.cfedda3c2e0d3c5d060bc370759a6c2c.svg";
export { ForwardRef as ReactComponent };